var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{directives:[{name:"clickoutside",rawName:"v-clickoutside",value:(_vm.handleBlur),expression:"handleBlur"}],staticClass:"common-button",class:[
    _vm.type ? 'common-button--' + _vm.type : '',
    _vm.size ? 'common-button--' + _vm.size : '',
    {
      'is-disabled': _vm.disabled,
      'is-loading': _vm.loading,
      'is-active': _vm.isActive,
      'is-plain': _vm.plain
    }
  ],style:(Object.assign({}, _vm.textColor)),attrs:{"disabled":_vm.disabled || _vm.loading,"autofocus":_vm.autofocus,"type":_vm.nativeType},on:{"click":_vm.handleClick}},[(_vm.icon)?_c('svg-icon',{staticClass:"left-icon",attrs:{"name":_vm.icon}}):_vm._e(),(_vm.$slots.default)?_c('span',[_vm._t("default")],2):_vm._e(),(_vm.loading)?_c('div',{staticClass:"common-loading"},[_c('i',{staticClass:"loading-icon"})]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }